import React from 'react';
import './BookVenue.css';

const BookVenue = () => {
    return (
        <div className="scholarship-banner-container">
            <div className="scholarship-banner-overlay">
                <div className="scholarship-bubbles">
                    {[...Array(10)].map((_, index) => (
                        <span key={index} className="scholarship-bubble"></span>
                    ))}
                </div>
            </div>
            <div className="scholarship-banner-content">
                <h1 className="scholarship-banner-heading">Book your dream venue today!</h1>
                <p className="scholarship-banner-subheading">The Golden Palace</p>
                <button className="scholarship-banner-button">Book Now</button>
            </div>
        </div>
    );
};

export default BookVenue;
